module.exports = __webpack_public_path__ + "img/compact_disc_grey.09413bfb.svg";